import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuDivider from 'components/atoms/Editors/EditorMenuDivider/EditorMenuDivider.styles';

const EditorMenuDivider = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'EditorMenuDivider');

  return <StyledEditorMenuDivider ref={ref} {...innerProps} />
});

EditorMenuDivider.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuDivider;
